import ResourceList from './index.js';
import Publish from './components/publish';

export default [
  {
    title: '',
    path: '/list',
    component: ResourceList,
  },
  {
    title: '发布资源',
    path: '/publish',
    component: Publish,
    hideInNav: true,
  },
];
